//This service is for handling all SSP related data.
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CssThemesService } from 'src/app/services/css-themes.service';
import { IClaim, emptyClaim } from 'src/app/shared/models/claim.interface';
import { environment } from '../../environments/environment';
import { ApiEndpoints } from 'src/config/api-endpoints';
import { IChannelPartnerShipmentDetails, IShippingDetailsAutofill, emptyChannelPartnerShipmentDetails, emptyShippingDetails, emptyShippingDetailsWithErrorResponse, hardCodedChannelPartnerShipmentDetails, hardCodedTrack3ShipmentDetails } from 'src/app/shared/models/shippingDetails.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { ClaimService } from 'src/app/services/claim.service';
import { UserService } from 'src/app/services/user.service';
import { TupssService } from '../pages/claims-custom/tupss/services/tupss.service';
import { IShipInterface } from '../pages/claims-custom/tupss/interfaces/claim-data.interface';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';
import { PolicyService } from './policy.service';
@Injectable({
  providedIn: 'root'
})
export class SspDataService {
  commonClaimsInterface$ = new BehaviorSubject<IClaim>(null);
  _commonClaimsInterface: IClaim;
  shipmentData;
  channelPartnerShipmentDetails$ = new BehaviorSubject<IChannelPartnerShipmentDetails>(null);
  _channelPartnerShipmentDetails: IChannelPartnerShipmentDetails;
  iShipDetails$ = new BehaviorSubject<IShipInterface>(null);
  _iShipDetails: IShipInterface;

  constructor(
    private router: Router,
    private themeService: CssThemesService,
    private http: HttpClient,
    private claimService: ClaimService,
    private userService: UserService,
    private tupssService: TupssService,
    private policyService: PolicyService
  ) {
    this.setCommonClaimsInterface(JSON.parse(sessionStorage.getItem('claimModel')));
    this.setPartnerShipmentDetails(JSON.parse(sessionStorage.getItem('partnerShipmentDetails')));
  }

  setPartnerShipmentDetails(shipmentDetails: IChannelPartnerShipmentDetails) {
    this._channelPartnerShipmentDetails = shipmentDetails;
    this.channelPartnerShipmentDetails$.next(shipmentDetails);
    sessionStorage.setItem('partnerShipmentDetails', JSON.stringify(shipmentDetails));
  }

  getPartnerShipmentDetails() {
    return this.channelPartnerShipmentDetails$;
  }

  deleteChannelPartnerShipmentDetails() {
    this.setPartnerShipmentDetails(null);
  }

  //Set service variable & BehaviorSubject
  setCommonClaimsInterface(claimData: IClaim) {
    this._commonClaimsInterface = claimData;
    this.commonClaimsInterface$.next(claimData);
    sessionStorage.setItem('claimModel', JSON.stringify(claimData));
  }

  //Get BehaviorSubject
  getCommonClaimsInterface() {
    return this.commonClaimsInterface$;
  }

  //Set service variable & BehaviorSubject
  setIShipDetails(iShipData: IShipInterface) {
    this._iShipDetails = iShipData;
    this.iShipDetails$.next(iShipData);
  }

  //Get BehaviorSubject
  getIShipDetails() {
    return this.iShipDetails$;
  }

  //get call back url for ccp DPAT redirection
  getCallBackURL(urlBase: string, partner: string) {
    let callBackURL = `${urlBase}ssp/${partner}/detail`;
    return callBackURL;
  }


  populateClaimInterfaceUsingPartnerInfo(shipmentDetails: IChannelPartnerShipmentDetails) {
    this.simpleSetup();
    let email = JSON.parse(sessionStorage.getItem('self-service-landing'))?.email;
    let claimData = {
      shippingDetailsDTO: {
        shipperCompanyName: shipmentDetails.shipperName,
        shipDate: shipmentDetails.shipDate,
        shipperAddressLine: shipmentDetails.originAddress,
        shipperCity: shipmentDetails.originCity,
        shipperStateProvinceCode: shipmentDetails.originState,
        shipperPostalCode: shipmentDetails.originPostalCode,
        shipperCountryCode: shipmentDetails.originCountryCode,
        consigneeAddressLine1: shipmentDetails.destinationAddress,
        consigneeCity: shipmentDetails.destinationCity,
        consigneeStateProvinceCode: shipmentDetails.destinationState,
        consigneePostalCode: shipmentDetails.destinationPostalCode,
        consigneeCountryCode: shipmentDetails.destinationCountryCode,
        senderDetails: {
          companyName: shipmentDetails.shipperName,
          city: shipmentDetails.originCity,
          state: shipmentDetails.originState,
          country: shipmentDetails.originCountryCode,
          zipCode: shipmentDetails.originPostalCode,
          address1: shipmentDetails.originAddress
        },
        receiverDetails: {
          companyName: shipmentDetails.consigneeName,
          city: shipmentDetails.destinationCity,
          state: shipmentDetails.destinationState,
          country: shipmentDetails.destinationCountryCode,
          zipCode: shipmentDetails.destinationPostalCode,
          address1: shipmentDetails.destinationAddress
        },
        originScan: ''
      },
      originScan: '',
      trackingNumber_Ext: shipmentDetails.trackingNumber,
      transportationCarrierId_Ext: shipmentDetails.carrier,
      lossDate: shipmentDetails.shipDate ? shipmentDetails.shipDate : '',
      claimSource: 'CCP4CP',
      groupCode: email ? email : ''
    }

    let claim = _.merge(this._commonClaimsInterface, claimData);
    this.setCommonClaimsInterface(claim);
  }

  //My choice and Tupss need the emptyclaim start. Otherwise they are missing policy object, maincontact object, etc.
  //Normal flow does not need this step.
  simpleSetup() {
    this.updateCommonClaimObject(emptyClaim);
  }

  //Only SSP users come through this, includes upshealthcare
  gatherPartnerShipmentDetails(trackingNumber: string, partnerName: string): Observable<any> {
    let endpoint = `${environment.baseUrl.api}${ApiEndpoints.DATABRICKS_SHIPMENT_DETAILS}`;
    let request = {
      trackingNum: trackingNumber,
      isInXpress: false,
      partnerFlow: partnerName == 'upshealthcare' ? 2 : 0
    }
    //Partner Flow logic:
    //0 - ssp or pirateship - no insured value check
    //1 - ccp not pirateship - check for < 1
    //2 - usphealthcare - check for < 101
    return this.http.post<any>(endpoint, request).pipe(map(
      response => {
        if (partnerName == 'upshealthcare' && response?.message?.toLowerCase() == 'not covered') {
          return { error: "upshealthcare insured amount error" };
        } else if (partnerName == 'upshealthcare' && response?.code == 200 && response?.message?.toLowerCase() == 'succeeded') {
          this.setPartnerShipmentDetails(response.data);
          return { message: "succeeded", policyNumber: response.data.policyNumber };
        } else if (response?.code === 200 && response?.message.toLowerCase() === 'succeeded') {
          this.setPartnerShipmentDetails(response.data);
          return { message: "succeeded", policyNumber : response.data.policyNumber};
        } else if (response?.code === 200 && response?.message.toLowerCase() === 'tracking number not found') {
          return { error: "tracking number not found" };
        }
      },
      error => {
        if (error?.code === 500 && error?.message.toLowerCase() === 'timeout occurred') {
          return { errorMessage: "timeout occurred" };
        } else {
          this.setPartnerShipmentDetails(emptyChannelPartnerShipmentDetails);
          return { errorMessage: 'internal error' };
        }
      }
    ));
  }



  //Cleaning up some formats so we are sure that GW won't throw validation errors
  //This should be called before any claim request.
  formatPayloadBeforeAnyAPIRequest() {
    let tempClaim = this._commonClaimsInterface;
    //Remove "currency" from the money amounts. Sometimes would send "10.00 usd" or something like that. Should be "10.00".
    tempClaim.shippingDetailsDTO.verifiedShippingCharge = tempClaim.shippingDetailsDTO.verifiedShippingCharge?.split(" ")[0];
    tempClaim.shippingDetailsDTO.merchandiseValue = tempClaim.shippingDetailsDTO.merchandiseValue?.split(" ")[0];
    tempClaim.shippingDetailsDTO.invoiceAmount = tempClaim.shippingDetailsDTO.invoiceAmount?.split(" ")[0];

    //GW Does not like the extra zero at the end of the dates.
    //Used to be lossDate:"2023-05-03T04:00:00.000Z".
    //Now should be lossDate:"2023-05-03T04:00:00Z".
    let tempLD = tempClaim.lossDate ? new Date(tempClaim.lossDate).toISOString() : '';
    tempClaim.lossDate = tempLD.replace(".000Z", "Z");
    let tempSD = tempClaim.shippingDetailsDTO.shipDate ? new Date(tempClaim.shippingDetailsDTO.shipDate).toISOString() : '';
    tempClaim.shippingDetailsDTO.shipDate = tempSD.replace(".000Z", "Z");

    //This fixes insuredAmount being something like 17.00000000001
    let tempIV = tempClaim.shippingDetailsDTO.insuredAmount;
    if (tempIV) {
      tempIV = Number(tempIV).toFixed(2).toString();
      tempClaim.shippingDetailsDTO.insuredAmount = tempIV;
    }

    //This fixes claimAmount being something like 17.00000000001
    let tempCA = tempClaim.claimAmount_Ext;
    if (tempCA) {
      tempCA = Number(tempCA).toFixed(2).toString();
      tempClaim.claimAmount_Ext = tempCA;
    }

    //TruCore was sending "CargoEdge" as policytype, which is incorrect. Using the output from determinePolicyType, we are able to fix it on our end.
    let policy = JSON.parse(sessionStorage.getItem('policyDetails'));
    if (this.policyService.determinePolicyType(policy) == 'transactional_cargo' || this.policyService.determinePolicyType(policy) == 'traditional_cargo') {
      tempClaim.policy.policyType = 'Cargo_Ups';
    }

    if(this.userService.getUserInfo().type == 'self-service-portal') {  //SSP
        let claimFlow = `ssp/${sessionStorage.getItem('partner')}`;
        let email;
        if (tempClaim?.mainContact?.emailAddress1) {
          email = `&email=${tempClaim.mainContact.emailAddress1}`;
        } else {
          email = `&email=${JSON.parse(sessionStorage.getItem('self-service-landing'))?.email}`;
        }

        tempClaim.dynamicURLBase = environment.baseUrl.web;
        tempClaim.dynamicURLEncoded = `${claimFlow}/detail?policyNumber=${policy.policyNumber}&claimNumber=CLAIM_NUM${email}`;
    }

    this.updateCommonClaimObject(tempClaim);
  }

  updateCommonClaimObject(claimData: IClaim) {
    let claim = _.merge(this._commonClaimsInterface, claimData);
    let policy = JSON.parse(sessionStorage.getItem('policyDetails'));
    claim.policy.policyNumber = policy?.policyNumber;
    claim.policy.effectiveDate = policy?.effectiveDate;
    claim.policy.expirationDate = policy?.expirationDate;
    claim.policy.insured = policy?.insured;
    claim.policy.policyType = policy?.policyType.key;
    this.setCommonClaimsInterface(claim);
  }
}
